import Fab from "@mui/material/Fab";
import React, { MouseEvent } from "react";
import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getSmoothStepPath,
} from "reactflow";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useDispatch } from "react-redux";
import { removeSelectedEdge } from "../../store/game/gameSlice";

const ReactFlowEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  sourcePosition,
  targetX,
  targetY,
  targetPosition,
  selected,
}) => {
  const dispatch = useDispatch();
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const handleEdgeDelete = (
    e: MouseEvent<HTMLButtonElement>,
    edgeID: string
  ) => {
    e.stopPropagation();
    dispatch(removeSelectedEdge(edgeID));
  };

  return (
    <>
      <BaseEdge id={id} path={edgePath} />
      <EdgeLabelRenderer>
        {selected && (
          <div
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${
                labelX + 50
              }px,${labelY}px)`,
              fontSize: 12,
              // everything inside EdgeLabelRenderer has no pointer events by default
              // if you have an interactive element, set pointer-events: all
              pointerEvents: "all",
            }}
            className="nodrag nopan"
          >
            <Fab
              color="primary"
              aria-label="add"
              size="small"
              style={{ transform: "scale(0.7)" }}
              onClick={(e) => {
                handleEdgeDelete(e, id);
              }}
            >
              <DeleteOutlineIcon />
            </Fab>
          </div>
        )}
      </EdgeLabelRenderer>
    </>
  );
};

export default ReactFlowEdge;
